export default function Form()
{

    const $body = $('body')
    const selector = 'form .form-field-inner :input'

    $body.on('focus', selector, function(){
        $(this).parents('.form-field-inner').addClass('focus')
    }).on('blur', selector, function(){
        $(this).parents('.form-field-inner').removeClass('focus')
    })

    // Handle the copy to clipboard feature
    $body.on('focus', '.copy-to-clipboard', function(){

        // Get the input
        const $input = $(this)

        // Select the input
        $input[0].select()

        // Set the range
        $input[0].setSelectionRange(0, 99999)

        // Copy the text
        document.execCommand('copy')

        // Get the copied message
        const $copied = $input.parents('.form-field').find('label .copied')

        // Show the message
        $copied.show()

        // Hide the message after 10 seconds
        window.setTimeout(function(){

            // Hide the message
            $copied.hide()

            // Blur the input
            $input.blur()

        }, 10000)



    })

}
